import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'
import { Box, SxProps, Theme } from '@mui/system'
import { ReactNode } from 'react'
import { CardStandart } from './CardStandart'
import { TypographyHeader } from './typography/TypographyHeader'
import { TypographySecondary } from './typography/TypographySecondary'

interface AppCardProps {
	title: string
	description?: string
	onClick?: () => void
	disabled?: boolean
	showArrow?: boolean
	leftSlot?: ReactNode
	rightSlot?: ReactNode
	children?: ReactNode
	sx?: SxProps<Theme>
}

const AppCard = ({
	title,
	description,
	onClick,
	disabled = false,
	showArrow = true,
	leftSlot,
	rightSlot,
	children,
	sx = {},
}: AppCardProps) => {
	const clickable = Boolean(onClick) && !disabled

	return (
		<CardStandart
			onClick={clickable ? onClick : undefined}
			sx={{
				padding: '24px',
				display: 'flex',
				flexDirection: 'row',
				justifyContent: 'space-between',
				alignItems: 'center',
				cursor: clickable ? 'pointer' : 'default',
				opacity: disabled ? 0.5 : 1,
				...sx,
			}}
		>
			<Box display='flex' flexDirection='row' alignItems='center' gap='12px'>
				{leftSlot}
				<Box display='flex' flexDirection='column'>
					<TypographyHeader>{title}</TypographyHeader>
					{description && (
						<Box mt='24px'>
							<TypographySecondary>{description}</TypographySecondary>
						</Box>
					)}
					{children}
				</Box>
			</Box>
			{rightSlot ??
				(showArrow && (
					<ArrowForwardIosIcon sx={{ color: '#7F7F84' }} fontSize='small' />
				))}
		</CardStandart>
	)
}

export default AppCard
